import { FC } from 'react'
//components
import { useInViewFooter } from '../../../hooks/useInViewFooter'
import { useSendMessage } from '../../../hooks/useSendMessage'
import { isInViewFooterState, stepState, inquiryState, inputState, onetimeKeyState } from '../../../states/messageState'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { FooterContent } from '../FooterContent'
import { InputAndSubmitButton } from '../InputAndSubmitButton'
import { isEmail } from '../../../util/validation'
import { putUpdateEmail } from '../../../api/contracts'
import { useCheckPhone } from '../../../hooks/useCheckPhone'

export const InputUpdateEmail: FC = () => {
  const { handleInViewFooter } = useInViewFooter()
  const { handleAddSenderParent, handleAddMessage } = useSendMessage()
  const { checkPhone } = useCheckPhone()

  const [input, setInput] = useRecoilState(inputState)

  const inquiry = useRecoilValue(inquiryState)
  const onetimeKey = useRecoilValue(onetimeKeyState)

  const setIsInViewFooter = useSetRecoilState(isInViewFooterState)
  const setCurrentStep = useSetRecoilState(stepState)

  /**メールアドレス変更があった場合、有効メールアドレスかチェックしてから住所チェック */
  const handleSubmitUpdateEmail = async () => {
    const { contractId } = inquiry
    setIsInViewFooter(false)
    setInput('')

    await handleAddSenderParent('user', input)

    if (!isEmail(input)) {
      await handleAddSenderParent('bot', `正しいメールアドレスの形式では無いようです。`)
      await handleAddMessage('bot', '再度入力してください。')
      handleInViewFooter()
      setCurrentStep('inputUpdateEmail')
      return
    }

    await putUpdateEmail({ contractId, email: input }, onetimeKey)
    await handleAddSenderParent('bot', `いただいた${input}に変更致します。`)

    await checkPhone(true)
  }

  return (
    <FooterContent isWide>
      <InputAndSubmitButton
        value={input}
        placeholder="変更後のメールアドレス"
        onChange={(e) => setInput(e.target.value)}
        onKeyPress={(e) => e.key === 'Enter' && handleSubmitUpdateEmail()}
        onClick={handleSubmitUpdateEmail}
      />
    </FooterContent>
  )
}
